<template>
	<div class="form-group" :class="{'has-error' : error}" id="as_topd">
		<label v-if="label" :for="for_label_comp" :id="for_label_comp + '_label'" class="form-row control-label" :class="{'is-required' : required}">
      <slot name="label">{{ label }}</slot>
      <span v-if="aria" class="sr-only">{{aria}}</span>
    </label>
		<slot/>
    <p v-if="error" class="error" v-html="error"></p>
	</div>
</template>

<script>

export default {
	name: 'IcFormRow',
	props: {
    error: {
      type: String,
      required: false
    }, 
    for_label: {
      type: String,
      required: false
    }, 
    label: {
      type: String,
      required: false,
    },
    new_id: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      default: false
    },
    aria: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      for_label_comp: ''
    }
  },  
  mounted: function(){
    if(!this.$attrs.id && this.new_id) this.$attrs.id = this.new_id;
    this.$el.id = this.id+"_parent";
    this.id = "parent_"+this.$attrs.id;

  },
  updated: function(){
    if(!this.$attrs.id && this.new_id) this.$attrs.id = this.new_id;
    if(!this.for_label) this.for_label_comp = this.$attrs.id; else this.for_label_comp = this.for_label;
    this.id = "parent_"+this.$attrs.id;
  },
  created: function(){
    if(!this.$attrs.id && this.new_id) this.$attrs.id = this.new_id;
    if(!this.for_label) this.for_label_comp = this.$attrs.id; else this.for_label_comp = this.for_label;
    this.id = "parent_"+this.$attrs.id;
  },
  
}

</script>

<style>
</style>